module.exports = __webpack_public_path__ + "img/default-article-large.175f3e6.jpg";